import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            minWidth: 120,
            width: '100%',
        },
        mt2: {
            marginTop: theme.spacing(2),
        },
        filterRow: {
            marginTop: theme.spacing(1),
        },
        btn: {
            marginTop: theme.spacing(2),
        },
    })
);
